import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGetFeedbackDataMutation } from "../redux/services/apiHome";
import useFetchIp from "./useFetchIp";

const usePageVisitTracker = () => {
  const { pathname } = useLocation();
  const { ip } = useFetchIp();
  const [postIpFunction] = useGetFeedbackDataMutation();

  useEffect(() => {
    if (ip) {
      const payload = {
        visitors_ip: ip,
        visitors_url: pathname,
        visitors_page_title: "Home",
      };
      postIpFunction({ url: "/v1/react_visitor", payload });
    }
  }, [ip, pathname, postIpFunction]);
};

export default usePageVisitTracker;
